module.exports = __webpack_public_path__ + "mv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mv.svg
// module id = 967
// module chunks = 0